import React, {Component} from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import '../../static/css/style.scss'
import MainNav from "../components/mainNav"
import api from "../../api/api"
import Notdata from "../components/notdata"
import InfiniteScroll from 'react-infinite-scroller'
class Activity extends Component {
	state={
		currentPage:1,
		pageSize:20,
		list:[],
		finished:false,
		hasMore:true,
		navs:[
			{name:'首页',link:'/'},
			{name:'留学活动',link:'/activity'},
		]
	}
	componentDidMount() {
		this.getList()
	}
	getList=async ()=>{
		let {currentPage,pageSize,finished,list}=this.state
		if (finished){
			return
		}
		let res=await api.get('/events/get-list',{currentPage,pageSize})
		let temp=[]
		if (currentPage===1){
			temp=res.data.data
		}else {
			temp=[...list,...res.data.data]
		}
		this.setState({
			list:temp,
		},()=>{
			let total=res.data.total
			if (this.state.list.length>=total){
				this.setState({hasMore:false,finished:true})
			}else {
				this.setState({hasMore:true})
			}
		})
	}
	render() {
		let {list,navs,hasMore,currentPage}=this.state
		return (
			<div className={'page'}>
				<Header/>
				<div className={'main'}>
					<MainNav navs={navs}/>
					<InfiniteScroll
						hasMore={hasMore}
						useWindow={true}
						initialLoad={false}
						loadMore={()=>{
							currentPage++
							this.setState({currentPage,hasMore:false},()=>{
								this.getList()
							})
						}}
					>
					<div className={'activityList'}>
						{
							list.map((item,index)=>(
								<div onClick={()=>{this.props.history.push('/activitydetail/'+item.id)}} key={index} className={'activityItem'}>
									<div className={'activityWrap'}>
										<img className={'activityImg'} src={item.image} alt=""/>
										<div className={'activityInfoBox'}>
											<div className={'activityTitle'}>{item.title}</div>
											<div className={'activityInfo'}>
												<img className={'activityIcon'} src={require('../../static/images/activetime.png')} alt=""/>
												<div className={'activityText'}>{item.date}</div>
											</div>
											<div className={'activityInfo'}>
												<img className={'activityIcon'} src={require('../../static/images/activemap.png')} alt=""/>
												<div className={'activityText'}>{item.location}</div>
											</div>
										</div>
									</div>
								</div>
							))
						}
						{
							list.length===0?<Notdata/>:null
						}
					</div>
					</InfiniteScroll>
				</div>
				<Footer/>
			</div>
		)
	}
}

export default Activity